// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#ffb601","navbar":"Navbar_navbar__38HqQ","logo":"Navbar_logo__t3h5w"};